import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { OpsOfLawModel } from '../models/ops-of-law.model';

@Injectable()
export class OpsOfLawIncidentService extends IncidentServiceBase<OpsOfLawModel> {
    constructor() {
        super('OpsOfLaw', () => new OpsOfLawModel());
    }
}
